"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NpcActorArgs = exports.PlayerV2ActorArgs = void 0;
const enums_1 = require("../enums");
class PlayerV2ActorArgs {
    constructor(faction, classType, level, initialAttributes, initialAbilities, initialEquipment, playerId, characterId, characterXp, characterXpToLevel, rarity = enums_1.Rarity.Common, permanents) {
        this.faction = faction;
        this.classType = classType;
        this.level = level;
        this.initialAttributes = initialAttributes;
        this.initialAbilities = initialAbilities;
        this.initialEquipment = initialEquipment;
        this.playerId = playerId;
        this.characterId = characterId;
        this.characterXp = characterXp;
        this.characterXpToLevel = characterXpToLevel;
        this.rarity = rarity;
        this.permanents = permanents;
        this.__type = "playerv2";
        this.archetypes = Array.of();
        this.effects = Array.of();
    }
}
exports.PlayerV2ActorArgs = PlayerV2ActorArgs;
class NpcActorArgs {
    constructor(faction, classType, level, initialAttributes, initialAbilities) {
        this.faction = faction;
        this.classType = classType;
        this.level = level;
        this.initialAttributes = initialAttributes;
        this.initialAbilities = initialAbilities;
        this.__type = "npc";
        this.rarity = enums_1.Rarity.Common;
        this.archetypes = Array.of();
        this.effects = Array.of();
        this.characterXp = 0;
        this.characterXpToLevel = Number.MAX_SAFE_INTEGER;
        this.playerId = undefined;
        this.characterId = undefined;
        this.aiKey = "None";
        this.aiArgs = undefined;
        this.initialEquipment = {};
    }
    withItem(slot, item) {
        this.initialEquipment[slot] = item;
        return this;
    }
    withAi(key, args) {
        this.aiKey = key;
        this.aiArgs = args;
        return this;
    }
    withPlayerId(playerId) {
        this.playerId = playerId;
        return this;
    }
    withCharacterId(characterId) {
        this.characterId = characterId;
        return this;
    }
    withEffects(...effects) {
        this.effects.push(...effects);
        return this;
    }
    withArchetypes(...archetypes) {
        this.archetypes.push(...archetypes);
        return this;
    }
}
exports.NpcActorArgs = NpcActorArgs;
